<template>
    <div class="card-page">
        <navBar :title="title" @onClickLeft="handleBack">
            <template slot="nav-left">
                <div></div>
            </template>
            <template slot="nav-right">
                <span class="icon icon-service" @click="showService = true"></span>
            </template>

        </navBar>
        <div class="card-detail">
            <div class="title">{{cardDetail.title}}<span>CARD</span><em></em>VIP</div>
            <div class="card-desc">
                <p class="desc">{{cardDetail.desc}}</p>
                <div class="card-status">
                    <div class="text-box">
                        <i class="icon icon-card"></i>
                        <div class="text">
                            <p>尊享会员<span class="rule-btn" @click="showRule = true">活动规则></span></p>
                            <div class="tips">激活会员卡领取会员权益</div>
                        </div>
                        
                    </div>
                    <div class="btn" :class="{'binded': bindStatus}" @click="handleBind">{{bindStatus?'已激活':'激活卡'}}</div>
                    
                </div>
            </div>
        </div>
        <div class="equity-list">
            <div class="equity-item" v-for="item in equityList" :key="item.id">
                <div class="sort">权益{{nums[item.id]}}</div>
                <div class="main-box">
                    <div class="intro-box">
                        <div class="title">{{item.title}}</div>
                        <div class="intro">{{item.intro}}</div>
                    </div>
                    <div class="btn" v-if="bindStatus" @click="$router.push(item.url)">查看</div>
                    <div class="btn" v-else @click="handleBind">去领取</div>
                </div>
                
            </div>
        </div>

        <van-action-sheet v-model="showRule" title="活动规则">
            <div class="rule-content">
                会员卡规则： <br>
                1.使用时间：此卡自购买之日起生效，截止使用时间为2023年5月31号。 <br>
                2.卡项包含的所有权益仅限兑换一次，一经兑换，不予退换。 <br>
                3.会员卡采用一人一卡制，一经激活将与您的账号绑定，不支持多人使用，不支持退款。 <br>
                4.权益领取方式：收到实体卡后，扫描卡上二维码，输入兑换码领取对应权益。 <br>
                5.本活动解释权归活动发起方所有。 <br> <br>
                课程兑换规则： <br>
                1. 课程兑换需要输入兑换码、有效手机号和姓名。 <br>
                2. 课程查看需要登录后点击"用户中心"查看课程。 <br>
                3. 如有问题，请添加客服二维码（页面客服二维码）。
            </div>
            <div class="get-rule-btn" @click="showRule = false">已了解</div>
        </van-action-sheet>

        <van-action-sheet v-model="showService" title="客服二维码">
            <div class="rule-content mini">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/service_qrcode.png" alt="">
                <p class="tips">保存二维码，微信扫一扫添加</p>
            </div>
            <div class="get-rule-btn" v-if="isWechat">长按图片保存二维码</div>
            <a download="客服" href="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/service_qrcode.png?response-content-type=application/octet-stream" v-else class="get-rule-btn">保存二维码</a>
        </van-action-sheet>
    </div>
</template>


<script>
import { Toast } from 'vant';
import {equityList, nums, cardList} from '../config/enum';
import navBar from '../components/navBar.vue';

export default {
    components: {
        navBar,
    },
    data() {
        return {
            nums,
            equityList,
            showService: false,
            showRule: false,
            bindStatus: false, // ture 已绑定
            hasCard: false,
            cardList,
            cardDetail: {
                title: '',
                desc: '',
            },
            title: this.$route.meta.title,
            cardName: this.$route.name,
            isLogin: localStorage.getItem('token'),
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            
        }
    },
    watch: {
        $route:{
            handler(n){
                this.isLogin = localStorage.getItem('token');
                this.cardName = this.$route.name;
                this.title = this.$route.meta.title;
                this.onCheckBindStatus();
                this.cardDetail = this.cardList[this.cardName];
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        onCheckBindStatus() {
            if(this.isLogin) {
                this.$api.entityCard.checkBindStatus().then(({success, data})=>{
                    if(success && data) {
                        this.hasCard = true;
                        const cardType ={
                            'rallyCard':'1',
                            'futureCard':'2',
                        }
                        this.bindStatus = cardType[this.cardName] == data.id;   
                    } else {
                        this.bindStatus = false;
                        this.hasCard = false;
                    }
                })
            }
        },
        handleBind() {
            const { bindStatus, hasCard } = this;
            if(!bindStatus) {
                if(hasCard) {
                    return Toast('手机号已绑定其他权益卡')
                }
                this.$router.push('/entityCard/binding')
            }
        },
        handleBack() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="less" scoped>
    .card-page {
        min-height: 100vh;   
    }
    ::v-deep {
        .van-action-sheet__header {
            font-size: 32/37.5rem;
            color: #333;
            line-height: 107/37.5rem;
            height: 107/37.5rem;
            position: relative;
            .van-action-sheet__close {
                position: absolute;
                top: 50%;
                right: 32/37.5rem;
                transform: translateY(-50%);
                width: 24/37.5rem;
                height: 24/37.5rem;
                padding: 0;
                &::before {
                    content: '';
                    width: 24/37.5rem;
                    height: 24/37.5rem;
                    background: url('../asset/images/close.png') no-repeat center center /100% 100%;
                    top: 0;
                    left: 0;
                    position: absolute;
                }
            }
        }
        .van-nav-bar__arrow {
            width: 56/37.5rem;
            height: 56/37.5rem;
            &::before{
                content: '';
                width: 56/37.5rem;
                height: 56/37.5rem;
                background: url('../asset/images/right.png') no-repeat center center /100% 100%;
            }
        }
        .van-nav-bar__content {
            background-color: #232834;
            .van-nav-bar__title {
                color: #fff;
            }
        }
        .van-hairline--bottom {
            &::after {
                display: none;
            }
        }
    }
    .icon-service {
        width: 44px;
        height: 44px;
        background: url('../asset/images/service.png') no-repeat center center /100% 100%;
        display: inline-block;
    }
    .equity-list {
        padding: 70px 30px;
        background-color: #fff;
        box-sizing: border-box;

        .equity-item {
            
            margin-bottom: 64px;
            font-size: 30px;

            position: relative;
            .sort {
                position: absolute;
                top: -40px;
                left: 0;
                height: 53px;
                background: url('../asset/images/title_bg.png') no-repeat center center /100% 100%;
                font-size: 28px;
                font-weight: 500;
                color: #FFEACD;
                line-height: 40px;
                padding: 0 34px 0 21px;
                z-index: 0;
            }
        }
        .main-box {
            display: flex;
            justify-content: space-between;
            background: #FFF4E4;
            border-radius: 15px;
            border: 1px solid #ECBF81;
            padding: 37px 26px;
            align-items: center;
            position: relative;
            z-index: 1;
            
        }
        .intro-box {
            flex: 1;
            .title {
                font-size: 30px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 40px;
                margin-bottom: 15px;
            }
            .intro {
                font-size: 28px;
                font-weight: 400;
                color: #666666;
                line-height: 38px;
            }
        }
        
        .btn {
            min-width: 168px;
            background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
            color: #fff;
            text-align: center;
            font-size: 30px;
            height: 64px;
            line-height: 64px;
            border-radius: 50px;
            margin-left: 60px;
        }
    }
    .card-detail {
        background-color: #232834;
        padding: 30px 30px 0;
        .title {
            font-size: 34px;
            font-weight: 600;
            color: #FFD28C;
            line-height: 48px;
            letter-spacing: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 28px;
            span {
                width: 94px;
                height: 43px;
                text-align: center;
                font-size: 25px;
                font-weight: 600;
                color: #232736;
                line-height: 43px;
                letter-spacing: 1px;
                display: inline-block;
                margin: 0 18px;
                background: linear-gradient(270deg, #FCE4B1 0%, #FFD390 100%);
                border-radius: 7px;
            }
            em {
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                margin-right: 15px;
                background-color: #FFD28C;
            }
        }
        .card-desc {
            background: url('../asset/images/card_black_bg.png') no-repeat center center /100% 100%;
            border-radius: 25px 25px 0px 0px;
            padding: 37px 24px 0;
            box-sizing: border-box;
            
            .desc {
                font-size: 26px;
                font-weight: 400;
                color: #EDEDED;
                line-height: 37px;
                margin-bottom: 12px;
                text-align: center;
            }
        }
        .card-status {
            background: url('../asset/images/card_bg.png') no-repeat center center /100% 100%;
            height: 187px;
            padding: 0 25px 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text-box {
                flex: 1;
                display: flex;
                align-items: center;
                .text {
                    font-size: 32px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 1;
                    p {
                        display: flex;
                        align-items: center;
                    }
                }
                .rule-btn {
                    font-size: 24px;
                    font-weight: 400;
                    color: #D08F35;
                    margin-left: 14px;
                }
                .tips {
                    font-size: 24px;
                    font-weight: 400;
                    color: #5E5E5E;
                    line-height: 33px;
                    margin-top: 14px;
                }
            }
            .icon-card {
                width: 80px;
                height: 80px;
                margin-right: 24px;
                background: url('../asset/images/icon_vip.png') no-repeat center center /100% 100%;
                border-radius: 50%;
            }
            .btn {
                width: 170px;
                height: 58px;
                background: #292623;
                border-radius: 29px;
                text-align: center;
                font-size: 28px;
                font-weight: 400;
                color: #FDD8BA;
                line-height: 58px;
                &.binded {
                    background: #FFFFFF;
                }
            }
        }
    }
    .rule-content {
        padding: 0 46px 60px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        box-sizing: border-box;
        height: 561px;
        overflow: auto;
        &.mini {
            height: 450px;
            padding-bottom: 0;
        }
        img {
            width: 269px;
            height: 269px;
            margin: 40px auto 36px;
            display: block;
        }
        .tips {
            text-align: center;
            font-size: 26px;
            font-weight: 400;
            color: #969696;
            line-height: 48px;
            margin-bottom: 50px;
        }
    }
    .get-rule-btn {
        width: 650px;
        height: 80px;
        background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
        border-radius: 50px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        margin: 30px auto 40px;
        text-align: center;
        line-height: 80px;
        display: block;
    }

</style>